import * as React from 'react';
export const SSRContext = React.createContext({});
export const SSRConfig = ({ notHydrating, ssrAspectRatio, ssrViewportWidth, children, }) => {
    const outerContextValue = React.useContext(SSRContext);
    const value = React.useMemo(() => ({
        notHydrating: notHydrating !== null && notHydrating !== void 0 ? notHydrating : outerContextValue.notHydrating,
        ssrAspectRatio: ssrAspectRatio !== null && ssrAspectRatio !== void 0 ? ssrAspectRatio : outerContextValue.ssrAspectRatio,
        ssrViewportWidth: ssrViewportWidth !== null && ssrViewportWidth !== void 0 ? ssrViewportWidth : outerContextValue.ssrViewportWidth,
    }), [notHydrating, ssrAspectRatio, ssrViewportWidth, outerContextValue]);
    return React.createElement(SSRContext.Provider, { value: value }, children);
};
